import { useIntl } from 'react-intl';
import DppModal from './DppModal';
import CO2ConsumptionsForm from '../forms/CO2ConsumptionForm';

const CO2ConsumptionModal = ({ show, onSave, onClose }) => {
  const intl = useIntl();
  const modalTitle = intl.formatMessage({ id: 'action_add_co2_consumptions' });

  const handleSave = (data) => {
    onSave?.(data);
    onClose();
  };

  const footerButtons = (
    <></>
  );

  return (
    <DppModal
      show={show}
      handleClose={onClose}
      title={modalTitle}
      footerButtons={footerButtons}
      size="lg"
      centered
    >
      <CO2ConsumptionsForm
        onSave={handleSave}
        onCancel={onClose}
        isModal={true}
      />
    </DppModal>
  );
};

export default CO2ConsumptionModal;